import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  Paper
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const TOTAL_STEPS = 8;

const Step4WorkField = ({
  onBack,
  onNext,
  selectedWorkField,
  setSelectedWorkField,
  currentStep = 7,  // assuming this is step 4 in your flow but progress bar at 7 (you can adjust)
  showHeader = true,
  className
  
}) => {
  const handleSelect = (field) => {
    setSelectedWorkField(field);
    onNext();
  };

  const workFields = [
    'Finance/Investment',
    'Technology/Software',
    'Arts/Entertainment',
    'Healthcare/Medical',
    'Law/Legal',
    'Education',
    'Marketing/Sales',
    'Hospitality/Real Estate',
    'Other',
    'Prefer not to say',
  ];

  const renderSegmentedProgressBar = () => (
    <Box display="flex" gap={1} mb={2}>
      {Array.from({ length: TOTAL_STEPS }).map((_, index) => (
        <Box
          key={index}
          flex={1}
          height={4}
          borderRadius={5}
          sx={{
            backgroundColor: index < currentStep ? '#0D99FF' : '#e0e0e0',
            transition: 'background-color 0.3s ease',
          }}
        />
      ))}
    </Box>
  );

  return (
    <Box display="flex" alignItems="start" justifyContent="center" className={className}>
      <Paper elevation={3} sx={{ position: 'relative', boxShadow: 'none', width: '100%' }}>
         {showHeader && (
        <>
        {/* Progress Bar */}
        {renderSegmentedProgressBar()}

        {/* Top Bar: Back + Title + Skip */}
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Box display="flex" alignItems="center">
            <IconButton onClick={onBack}>
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography variant="body1" fontWeight="600" ml={1}>
              Profile Setup
            </Typography>
          </Box>
          <Button onClick={onNext} sx={{ textTransform: 'none' }}>
            Skip
          </Button>
        </Box>
        </>
         )}

        {/* Heading */}
        <Typography
          variant="h5"
          fontWeight={600}
          mb={2}
          align="center"
          fontFamily="ivypresto-headline, serif"
        >
          What Field Do You Work In?
        </Typography>

        {/* Work Field Options */}
        <Box display="flex" flexWrap="wrap" justifyContent="center" gap={1.5}>
          {workFields.map((field) => (
            <Button
              key={field}
              variant={selectedWorkField === field ? 'contained' : 'outlined'}
              onClick={() => handleSelect(field)}
              sx={{
                px: 2,
                py: 1,
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: { xs: '12px', sm: '14px' },
                border: selectedWorkField === field ? '1px solid #2B1E1A' : '1px solid #CFD9DE',
                backgroundColor: selectedWorkField === field ? '#2B1E1A' : 'transparent',
                color: selectedWorkField === field ? '#fff' : 'inherit',
                '&:hover': {
                  backgroundColor: selectedWorkField === field ? '#2B1E1A' : '#f5f5f5',
                },
              }}
            >
              {field}
            </Button>
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default Step4WorkField;
